import { render, staticRenderFns } from "./Wendy.vue?vue&type=template&id=5d63c5da&"
import script from "./Wendy.vue?vue&type=script&lang=js&"
export * from "./Wendy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports